import ninegrid from "../index.js";

export class nxTitle extends HTMLElement {

	#breadcrumbPath = [];		// Breadcrumb 경로를 저장할 내부 상태 초기화
	#dynamicPath = []; // 동적으로 추가할 빵 부스러기 경로 (상세 페이지 등)


	constructor() {
		super();
		this.attachShadow({ mode: "open" });
	}

	connectedCallback() {
		this.#init();
	}

	// 컴포넌트가 DOM에서 제거될 때 이벤트 리스너를 정리
	disconnectedCallback() {
		document.removeEventListener('DOMContentLoaded', this.#init);
	}

	setDynamicPath(pathArray) {
		this.#dynamicPath = pathArray;
		this.#generateBreadcrumb(); // 빵 부스러기 재생성 및 렌더링
		this.#renderer();
	}

	#init = () => {
		/**
		console.log("111");
		const activeMenuItem = ninegrid.delayQuerySelector('nx-side-menu-item.active');
		console.log(activeMenuItem);

		this.#generateBreadcrumb(); // 빵 부스러기 데이터 생성 및 최종 렌더링 트리거
		this.#renderer(); // 초기 렌더링 (빵 부스러기 데이터는 아직 없음)
		*/
		ninegrid.delayQuerySelector('nx-side-menu-item.active')
			.then((el) => {
				this.#generateBreadcrumb(el); // 빵 부스러기 데이터 생성 및 최종 렌더링 트리거
				this.#renderer(); // 초기 렌더링 (빵 부스러기 데이터는 아직 없음)
			});
	};

	// Breadcrumb 경로를 구성하는 비공개 메서드
	#generateBreadcrumb = (activeMenuItem) => {
		this.#breadcrumbPath = [];


		// 'active' 클래스를 가진 가장 하위 nx-side-menu-item 찾기
		//const activeMenuItem = ninegrid.querySelector('nx-side-menu-item.active');
		//console.log(activeMenuItem);

		if (activeMenuItem) {

			// 1. 현재 활성화된 메뉴 항목의 캡션을 추가 (예: '심의자료')
			const currentActiveCaption = activeMenuItem.caption;//activeMenuItem.caption;

			if (currentActiveCaption) {
				this.#breadcrumbPath.unshift({
					path: activeMenuItem.getAttribute("href"),
					caption: currentActiveCaption,
				});
			}

			// 2. 현재 activeMenuItem의 이전 형제들을 탐색하여 'group'이 아닌 상위 메뉴(예: '심의자료')를 찾고,
			//    그 이전에 있는 'group' 메뉴(예: '자료관리')를 찾습니다.
			let currentElement = activeMenuItem;
			let foundNonGroupParent = false; // '자료관리'와 '심의자료' 사이의 메뉴를 찾았는지 여부
			let foundGroupParent = false;    // '자료관리' 그룹을 찾았는지 여부

			// activeMenuItem부터 이전 형제들을 역으로 탐색
			while (currentElement) {
				// 현재 activeMenuItem이 'group' 속성이 없는 일반 메뉴일 경우,
				// 바로 그 자체가 두 번째 레벨 메뉴(예: '심의자료')의 역할을 합니다.
				// 이미 activeMenuItem의 캡션은 추가되었으므로 여기서는 건너뜁니다.

				// 이전 형제 탐색
				currentElement = currentElement.previousElementSibling;

				if (currentElement && currentElement.tagName === 'NX-SIDE-MENU-ITEM') {
					const caption = currentElement.caption;//.getAttribute('caption');

					// 'group' 속성을 가진 메뉴 항목 찾기 (예: '자료관리')
					if (currentElement.getAttribute('type') === "group") {
						if (caption && !foundGroupParent) { // 이미 찾지 않은 경우에만 추가

							this.#breadcrumbPath.unshift({
								path: currentElement.getAttribute("href"),
								caption: caption,
							});
							foundGroupParent = true;
						}
						// 그룹을 찾으면 탐색 중단 (가장 가까운 상위 그룹만 필요)
						break;
					}
						// 'group' 속성이 없고, 아직 '심의자료' 같은 중간 부모를 찾지 않았다면 추가
						// (activeMenuItem이 이미 최하위 메뉴 캡션을 가지고 있으므로,
					// 이 로직은 activeMenuItem이 아닌 그 위의 일반 메뉴를 위한 것임)
					else if (caption && !foundNonGroupParent) {
						// 이 부분은 currentActiveCaption이 '심의자료 상세'이고,
						// activeMenuItem 자체가 '심의자료'일 때 문제가 될 수 있으니 주의
						// 만약 activeMenuItem이 항상 최하위 캡션을 가진다면,
						// 이 nonGroupParent 로직은 activeMenuItem의 직접적인 부모 (그룹이 아닌)를 찾는 데 쓰여야 함.
						// 현재 시나리오에서는 'activeMenuItem'이 '심의자료' 역할을 할 가능성이 높음.
						// '심의자료 상세'는 currentPageCaption이므로.

						// activeMenuItem이 '심의자료' 역할을 한다고 가정하고,
						// 이 루프에서는 그 '심의자료' 위의 '자료관리' 그룹만 찾도록 수정합니다.
						// 즉, previousElementSibling은 현재 active 메뉴의 "옆에 있는" 그룹을 찾아야 합니다.
					}
				}
			}

			// tempPath의 내용을 Home 다음으로 삽입
			// activeMenuItem이 '심의자료' 역할을 하고, 그 이전에 '자료관리' 그룹이 있다면
			// tempPath: ['자료관리', '심의자료']

		}

		// 마지막으로 현재 페이지의 구체적인 제목 추가
		// 현재 nx-title의 캡션을 현재 페이지 캡션으로 사용
		if (!this.closest(".list-wrapper")) {
			this.#breadcrumbPath.push({
				path: "",
				caption: this.getAttribute("caption") || "Current Page",
			});
		}

		this.#breadcrumbPath.unshift({
			path: "/",
			caption: "Home",
		});

		//console.log(this.#dynamicPath)

		// 2. 동적으로 추가된 경로 (상세 페이지)
		// #dynamicPath 배열의 내용을 병합
		this.#breadcrumbPath = this.#breadcrumbPath.concat(this.#dynamicPath);

//console.log(this.#breadcrumbPath);
		//this.#breadcrumbPath = path;
		//this.#renderer();
	};

	#renderer = () => {
		const el = ninegrid.querySelector('nx-side-menu-item.active');
		//console.log(el);

		const caption = el ? el.caption : "No Caption";

		// 내부 HTML (Light DOM)은 이 컴포넌트의 자식으로 넘어오는 콘텐츠이므로,
		// Breadcrumb에서는 사용하지 않는다면 제거하는 것이 맞습니다.
		// 여기서는 이전에 contents 변수에 저장했지만 사용하지 않았으므로, 제거 로직을 유지합니다.
		const contents = this.innerHTML.trim();
		this.innerHTML = ""; // 기존 내부 HTML 제거

		// Shadow DOM 초기화 (새로운 콘텐츠를 위해)
		this.shadowRoot.innerHTML = "";



		const htmlTmpl = document.createElement("template");
		htmlTmpl.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxTitle.css";
				${ninegrid.getCustomPath(this,"nxTitle.css")}
			</style>
            
            <div class="wrapper">
                <div class="title-wrapper">
                	<div class="bar1"></div>
                	<div class="bar2"></div>
                	<div class="bar3"></div>
                    <i class="title-icon"></i> 
                    <span class="title-text">${caption}</span>
                    <div class="bar7"></div>
                	<div class="bar8"></div>
                	<div class="bar9"></div>
                </div>
                <div class="breadcrumb-container">
                    ${this.#breadcrumbPath.map((item, index) => {
						
						const isCurrent = index === this.#breadcrumbPath.length - 1;
						// static 메서드를 직접 호출하도록 수정
						const linkTag = item.path && !isCurrent
							? `<a href="javascript:void(0);"
											class="breadcrumb-item breadcrumb-link"
											data-path="${item.path}"
											>${item.caption}</a>`
							: `<span class="breadcrumb-item ${isCurrent ? 'breadcrumb-current' : ''}">${item.caption}</span>`;
			
						const separator = index < this.#breadcrumbPath.length - 1
							? `<span class="breadcrumb-separator"> &gt; </span>`
							: '';
			
						return `${linkTag}${separator}`;
					}).join('')}
                </div>
            </div>
        `;

		this.shadowRoot.appendChild(htmlTmpl.content.cloneNode(true));

		this.shadowRoot.querySelectorAll('.breadcrumb-link').forEach(link => {
			link.addEventListener('click', this.#menuClickHandler);
		});
	}

	#menuClickHandler = (e) => {
		console.log(e);
		const path = e.target.dataset.path;
		if (path) {
			window.location.href = path;
		}
	}
}

if (!customElements.get('nx-title')) {
	customElements.define("nx-title", nxTitle);
}